module.exports = __webpack_public_path__ + "static/Teacher-Page-4aa4dc8c8f13ad22f904b6d0877afc89.jpg";